import React, { lazy } from "react";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import saga from "./saga";

const SitesPage = lazy(() => import("./SitesPage"));
const SitePage = lazy(() => import("./SitePage"));
const FleetPage = lazy(() => import("./FleetPage"));
const StaffSitePage = lazy(() => import("./StaffSitePage"));
const ScanPage = lazy(() => import("./ScanPage"));

const adaScans = {
    id: "ada-scans",
    name: "ADA Scans",
    nav: [{ label: "Accessibility", path: "/plugins/ada-scans", icon: AccessibilityNewIcon }],
    routes: [
        { path: "/plugins/ada-scans", element: <SitesPage /> },
        { path: "/plugins/ada-scans/site", element: <SitePage /> },
    ],
    internal: {
        nav: [{ label: "Accessibility Scans", path: "/plugins/ada-scans/fleet", icon: AccessibilityNewIcon }],
        routes: [
            { path: "/plugins/ada-scans/fleet", element: <FleetPage /> },
            { path: "/plugins/ada-scans/fleet/clients/:clientId/site", element: <StaffSitePage /> },
            { path: "/plugins/ada-scans/fleet/scans/:scanId", element: <ScanPage /> },
        ],
    },
    saga,
};

export default adaScans;
